import { render, staticRenderFns } from "./PurchaseDuoBrand.vue?vue&type=template&id=7e283fe8&"
import script from "./PurchaseDuoBrand.vue?vue&type=script&lang=js&"
export * from "./PurchaseDuoBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports